import { IAssessment } from "./main.interfaces";
import xlsx from "xlsx";
import { i18n } from "../main";
import { saveAs } from "file-saver";

const fileExtension = ".xlsx";

function saveWorkbook(workbook: any, fileName: string) {
  const workbookToExport = xlsx.write(workbook, {
    bookType: "xlsx",
    type: "binary"
  });
  saveAs(
    new Blob([s2ab(workbookToExport)], {
      type: "application/octet-stream"
    }),
    fileName + fileExtension
  );
}

/**
 * This function is provided by sheetJs and converts a workbook to an Array Buffer.
 * Source: https://stackoverflow.com/questions/34993292/how-to-save-xlsx-data-to-file-as-a-blob
 * @param s Workbook to be converted to buffer.
 */
function s2ab(s: any) {
  let buf = new ArrayBuffer(s.length);
  let view = new Uint8Array(buf);
  for (let i = 0; i != s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}

/**
 * Creates an excel-workbook and appends a workbook-sheet containing all data of the given assessment-list
 * @param assessmentEntries An Array of assessment-objects that will be exported.
 */
export function exportAssessmentList(assessmentEntries: IAssessment[]) {
  const workbook = xlsx.utils.book_new();
  workbook.Props = {
    Title: "Assessmentlist"
  };
  const itemToOA = [
    {
      A: i18n.t("generics.terms.nameOfProcess"),
      B: i18n.t("generics.terms.department"),
      C: i18n.t("generics.terms.organization"),
      D: i18n.t("generics.terms.creator"),
      E: i18n.t("generics.terms.createdAt"),
      F: i18n.t("generics.terms.easeOfImplementation") + " (%)",
      G: i18n.t("generics.terms.benefit") + " (%)",
      H: i18n.t("generics.terms.freedCapacity"),
      I: i18n.t("generics.terms.errorReduction") + " (%)",
      J: i18n.t("generics.terms.averageHandlingTimeReduction") + " (%)",
      K: i18n.t("generics.terms.effortToImplement")
    }
  ];

  assessmentEntries.forEach(element => {
    if (!element.department) {
      element.department = i18n.t("generics.terms.noDepartment") as string;
    }
    const elementData = {
      A: element.name,
      B: element.department,
      C: element.organization,
      D: element.creator,
      E: element.createdAt,
      F: element.outputs.easeOfImplementation,
      G: element.outputs.benefitSuitability,
      H: element.outputs.bandwidthFreed.toFixed(1),
      I: element.outputs.errorReduction.toFixed(1),
      J: element.outputs.averageHandlingTimeReduction.toFixed(1),
      K: element.outputs.effortToImplement
    };
    itemToOA.push(elementData as any);
  });
  const workSheetData = xlsx.utils.json_to_sheet(itemToOA, {
    skipHeader: true
  });

  xlsx.utils.book_append_sheet(workbook, workSheetData);
  saveWorkbook(workbook, i18n.t("generics.terms.assessmentData") as string);
}
